import type {
  ContentfulSliderProductsAutomaticFragment,
  ContentfulSliderProductsManualFragment,
} from '@/graphql/contentful/api';
import type {
  ContentfulData,
  ContentType,
  SectionsOpts,
} from '@/integrations/contentful';
import {
  getOptsForType,
  renderContentfulSection,
} from '@/integrations/contentful';

import type { AutomaticCarouselOpts } from '../Cms/AutomaticCarousel';
import { AutomaticCarousel } from '../Cms/AutomaticCarousel';
import { SliderProducts } from '../Cms/SliderProducts';

export const renderContentfulSearchNoResultsSection: any = (
  data: ContentfulData,
  sectionOpts: SectionsOpts,
  draftMode: boolean,
) => {
  const typename = data?.__typename as ContentType;
  if (typename === 'SliderProductsManual') {
    const props = data as ContentfulSliderProductsManualFragment;
    return renderManualCarousels(props, draftMode);
  }
  const section = renderContentfulSection(
    data,
    sectionOpts,
    undefined,
    draftMode,
  );

  if (section) {
    return section;
  }

  let props = null;

  switch (typename) {
    case 'SliderProductsAutomatic':
      props = data as ContentfulSliderProductsAutomaticFragment;
      return renderAutomaticCarousels(draftMode, props, sectionOpts);

    default:
      return null;
  }
};

const renderAutomaticCarousels = (
  draftMode: boolean,
  props: ContentfulSliderProductsAutomaticFragment,
  sectionOpts?: SectionsOpts,
) => {
  let opts = null;

  if (props.type === 'recently viewed') {
    opts = getOptsForType<AutomaticCarouselOpts>(
      'SliderProductsAutomatic',
      sectionOpts,
    ).find((opt) => opt.opts?.type === props.type)?.opts;
    return opts ? (
      <AutomaticCarousel
        data-test-id='AutomaticCarousel'
        {...props}
        {...opts}
        draftMode={draftMode}
      />
    ) : null;
  }

  return null;
};

const renderManualCarousels = (
  props: ContentfulSliderProductsManualFragment,
  draftMode?: boolean,
) => {
  return (
    <SliderProducts
      data-test-id='SliderProducts'
      {...props}
      autoLoadData={true}
      draftMode={draftMode}
    />
  );
};
